// Dispatcher d'entrée : page de login Keycloak (thème SATEQ) si Keycloak a injecté
// window.kcContext, sinon l'application dashboard normale (chargée à part).
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { KcPage } from "./keycloak-theme/kc.gen";

if (window.kcContext === undefined) {
  // App normale : on délègue à l'entrypoint dédié (qui a son propre createRoot).
  import("./index.app");
} else {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <KcPage kcContext={window.kcContext} fallback={null} />
    </StrictMode>
  );
}
